import { Component, input, output, viewChild, ElementRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-compact-search',
  standalone: true,
  imports: [FormsModule, LucideAngularModule],
  template: `
    <div
      class="flex items-center gap-2.5 h-9 px-3 rounded-xl border max-w-full transition-[box-shadow,border-color,background-color] duration-150 ease-out border-[color-mix(in_srgb,var(--border)_78%,transparent)] bg-[color-mix(in_srgb,var(--bg-surface)_94%,var(--hover))] shadow-[0_1px_2px_rgb(15_23_42/0.03)] focus-within:ring-2 focus-within:ring-[color-mix(in_srgb,var(--focus)_42%,transparent)] focus-within:border-[color-mix(in_srgb,var(--focus)_28%,var(--border))] focus-within:bg-[var(--bg-surface)]"
      [class.w-[200px]]="size() === 'compact'"
      [class.w-[320px]]="size() === 'list'"
      [class.min-w-[280px]]="size() === 'list'"
      [class.max-w-[360px]]="size() === 'list'"
      (click)="focusInput()"
    >
      <lucide-icon name="search" class="h-4 w-4 shrink-0 text-[var(--muted)] opacity-80" aria-hidden="true"></lucide-icon>
      <input
        #searchInput
        type="search"
        [ngModel]="value()"
        (ngModelChange)="valueChange.emit($event)"
        [placeholder]="placeholder()"
        class="flex-1 min-w-0 h-6 bg-transparent text-sm text-[var(--text)] placeholder:text-[color-mix(in_srgb,var(--muted)_55%,var(--faint))] border-0 focus:outline-none focus:ring-0"
      />
    </div>
  `,
})
export class CompactSearchComponent {
  value = input<string>('');
  valueChange = output<string>();
  /** 'compact' = 200px (header); 'list' = 280–360px (List View) */
  size = input<'compact' | 'list'>('compact');
  placeholder = input<string>('Buscar nesta lista');

  private searchInput = viewChild<ElementRef<HTMLInputElement>>('searchInput');

  focusInput(): void {
    this.searchInput()?.nativeElement?.focus();
  }
}
